import { createIcon } from '@chakra-ui/react';

export const StarsFilledLeft = createIcon({
  displayName: 'StarsFilledLeft',
  viewBox: '0 0 36.988 46.721',
  path: (
    <g
      id="Group_2860"
      data-name="Group 2860"
      transform="translate(24542.994 7984.581)"
    >
      <g
        id="Star_Filled_-_L"
        data-name="Star Filled - L"
        transform="translate(-24539 -7974.221)"
      >
        <path
          id="Star_Filled_-_L-2"
          data-name="Star Filled - L"
          d="M22.45,10.124a1.285,1.285,0,0,0-1.24-.937H14.731L12.741,2.78h0a1.289,1.289,0,0,0-1.226-.94h0a1.285,1.285,0,0,0-1.24.948L8.309,9.239,1.827,9.188h0a1.309,1.309,0,0,0-1.244.945,1.392,1.392,0,0,0,.486,1.523l5.277,3.958L4.289,22a1.394,1.394,0,0,0,.466,1.511,1.259,1.259,0,0,0,1.521.02l5.2-3.966,5.239,4.009a1.25,1.25,0,0,0,.768.266,1.273,1.273,0,0,0,.765-.262,1.378,1.378,0,0,0,.475-1.52l-1.973-6.444,5.239-3.969a1.368,1.368,0,0,0,.458-1.52Z"
          transform="translate(-0.521 -1.84)"
          fill="rgba(255,255,255,0.6)"
        />
      </g>
      <g
        id="Star_Filled_-_L-3"
        data-name="Star Filled - L"
        transform="translate(-24542.994 -7949.86)"
      >
        <path
          id="Star_Filled_-_L-4"
          data-name="Star Filled - L"
          d="M12.482,6.359a.7.7,0,0,0-.676-.511H8.272l-1.086-3.5h0a.7.7,0,0,0-.669-.513h0a.7.7,0,0,0-.676.517L4.769,5.876,1.233,5.848h0a.714.714,0,0,0-.678.515.759.759,0,0,0,.265.831L3.7,9.353,2.576,12.836a.76.76,0,0,0,.254.824.687.687,0,0,0,.83.011L6.5,11.508l2.857,2.187a.682.682,0,0,0,.419.145.7.7,0,0,0,.417-.143.752.752,0,0,0,.259-.829L9.375,9.353l2.857-2.165a.746.746,0,0,0,.25-.829Z"
          transform="translate(-0.521 -1.84)"
          fill="rgba(255,255,255,0.2)"
        />
      </g>
      <g
        id="Star_Filled_-_L-5"
        data-name="Star Filled - L"
        transform="translate(-24520.006 -7984.581)"
      >
        <path
          id="Star_Filled_-_L-6"
          data-name="Star Filled - L"
          d="M14.476,7.112a.817.817,0,0,0-.789-.6H9.564L8.3,2.438h0a.82.82,0,0,0-.78-.6h0a.818.818,0,0,0-.789.6L5.477,6.548,1.352,6.516h0a.833.833,0,0,0-.791.6.886.886,0,0,0,.309.969L4.228,10.6,2.919,14.668a.887.887,0,0,0,.3.962.8.8,0,0,0,.968.013l3.311-2.524,3.334,2.551a.8.8,0,0,0,.489.169.81.81,0,0,0,.487-.167.877.877,0,0,0,.3-.967l-1.256-4.1,3.334-2.526a.87.87,0,0,0,.291-.967Z"
          transform="translate(-0.521 -1.84)"
          fill="rgba(255,255,255,0.4)"
        />
      </g>
    </g>
  ),
});
